module.exports = __webpack_public_path__ + "static/img/企业章.686a5d70.png";